import { render, staticRenderFns } from "./work_item_popover.vue.js?vue&type=template&id=2efc6943!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=template&id=2efc6943"
import script from "./work_item_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=script&lang=js"
export * from "./work_item_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=script&lang=js"
import style0 from "./work_item_popover.vue.css?vue&type=style&index=0&id=2efc6943&lang=css!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=style&index=0&id=2efc6943&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efc6943')) {
      api.createRecord('2efc6943', component.options)
    } else {
      api.reload('2efc6943', component.options)
    }
    module.hot.accept("./work_item_popover.vue.js?vue&type=template&id=2efc6943!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=template&id=2efc6943", function () {
      api.rerender('2efc6943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "issuable/popover/components/work_item_popover.vue"
export default component.exports